import "./../../styles/Account.css";

import { useState } from "react";

import Container from "../../components/Layout/Container";

import Input, { onEnter } from "../../components/TextField/Input";
// import { RadioGroup } from '../../components/CheckboxRadio/Radio';
import { Button } from "../../components/Button/Button";

import Modal, { useToggleModal } from "../../components/Modal/Modal";
import { fetchGet, fetchPost } from "../../hooks/fetch";
import { openAlert } from "../../components/Modal/MsgBox";
import {
  isBlankStr,
  emailPattern,
  validateName,
  validatePwPattern,
  validatePhone,
  handlePhone,
  handleVerificationCode,
} from "../../hooks/useValidate";

export default function SignupRequest() {
  const pageName = "회원 가입";

  // const [membershipType, setMembershipType] = useState('GENERAL'); // 회원 종류
  const [userInfo, setUserInfo] = useState(userInfoDefault);
  const [isDuplicated, setIsDuplicated] = useState(true);

  const toggleModal = useToggleModal();

  const onChangeUserInfo = (e) => {
    const { name, value } = e.target;
    let save;
    if (name === "phone") {
      save = handlePhone(value);
    } else if (name === "verificationCode") {
      save = handleVerificationCode(value);
    } else {
      save = value;
    }

    if (name === "email") {
      setIsDuplicated(true);

      setUserInfo((prev) => ({
        ...prev,
        email: save,
        verificationCode: "",
      }));

      return;
    }

    // setUserInfo({
    // 	...userInfo,
    // 	[name]: save
    // });

    setUserInfo((prev) => ({
      ...prev,
      [name]: save,
    }));
  };

  // const selectMemberShipType = (e) => {
  // 	setUserInfo({
  // 		...userInfoDefault,
  // 		userType: e.target.value
  // 	});
  // 	setMembershipType(e.target.value);
  // }

  const validateSignupEmail = () => {
    if (isBlankStr(userInfo.email)) {
      openAlert("이메일을 입력해주세요.");
      return false;
    }
    if (!emailPattern.test(userInfo.email)) {
      openAlert("잘못된 형식의 아이디(이메일)입니다.");
      return false;
    }
    return true;
  };

  const checkDuplicatedId = () => {
    if (!validateSignupEmail()) return;

    fetchGet(
      `/users/signup/duplicate?loginId=${encodeURIComponent(userInfo.email)}&userType=GENERAL`,
      // `/users/signup/duplicate?loginId=${userInfo.email}&userType=GENERAL`,
      (json) => {
        setIsDuplicated(false);
        openAlert("사용 가능한 아이디(이메일)입니다.");
      },
      () => {
        setIsDuplicated(true);
      },
    );
  };

  // const sendSmsVerifyCode = () => {
  // 	fetchPost(
  // 		"/smsVerification/send/signup",
  // 		"인증번호를 전송",
  // 		{ phoneNumber: userInfo.phone }
  // 	)
  // }

  const sendEmailVerifyCode = () => {
    if (!validateSignupEmail()) return;
    if (!validateName(userInfo.name)) return;

    fetchPost("/emailVerification/send/signup", "인증번호를 전송", {
      email: userInfo.email,
      name: userInfo.name,
    });
  };

  const onKeyDown = (e) => {
    onEnter(e, submit);
  };

  const validateRequestInfo = () => {
    if (!validateSignupEmail()) return false;
    if (isDuplicated) {
      openAlert("아이디 중복 확인을 진행해주세요.");
      return false;
    }
    if (!validateName(userInfo.name)) return false;
    if (isBlankStr(userInfo.verificationCode)) {
      openAlert("인증번호를 입력해 주세요.");
      return false;
    }
    if (isBlankStr(userInfo.password)) {
      openAlert("비밀번호를 입력해 주세요.");
      return false;
    }
    if (!validatePwPattern(userInfo.password)) return false;
    if (isBlankStr(userInfo.passwordChk)) {
      openAlert("비밀번호 확인을 입력해주세요.");
      return false;
    }
    if (userInfo.password !== userInfo.passwordChk) {
      openAlert("비밀번호가 일치하지 않습니다.");
      return false;
    }
    if (!validatePhone(userInfo.phone)) return false;
    if (isBlankStr(userInfo.company)) {
      openAlert("소속을 입력해 주세요.");
      return false;
    }
    if (isBlankStr(userInfo.department)) {
      openAlert("부서를 입력해 주세요.");
      return false;
    }
    if (isBlankStr(userInfo.position)) {
      openAlert("직책을 입력해 주세요.");
      return false;
    }

    return true;
  };

  function submit() {
    if (!validateRequestInfo()) {
      return false;
    }

    // 회원가입
    fetchPost("/users/signup/email", "회원가입에 성공", userInfo, (json) => {
      window.location.replace("/account/login");
    });
  }

  return (
    <main id="account-page-wrap">
      <h1 className="sr-only">{`${pageName} 페이지`}</h1>

      <Container>
        <div className="page-content login-page">
          <div className="gs-account-form">
            <h1 className="top">{pageName}</h1>

            {/* <div>
							<RadioGroup
								id="membership-type-radio-buttons-group"
								itemClassName="round"
								name="rd_membership_type"
								ckeckOptions={membershipTypeOptions}
								checked={membershipType}
								onChange={selectMemberShipType}
							/>
						</div> */}
            <div>
              <Input.Group>
                {/* {membershipType === "cris"
									? <>
										<Input
											id="user-id"
											type="text"
											label="아이디(CRIS 사번)를 입력해주세요."
											placeholder="아이디(CRIS 사번) 입력"
											name="loginId"
											value={userInfo.loginId}
											onChange={onChangeUserInfo}
											maxLength={30}
											onKeyDown={onKeyDown}
										/>

										<Input.PasswordEye
											id="user-password"
											label="비밀번호(CRIS 비밀번호)를 입력해주세요."
											placeholder="비밀번호(CRIS 비밀번호) 입력"
											name="password"
											value={userInfo.password}
											onChange={onChangeUserInfo}
											maxLength={20}
											onKeyDown={onKeyDown}
										/>
									</>
									: <> */}
                <div className="gs-input-box flex">
                  <Input
                    id="user-id"
                    type="email"
                    label="아이디(이메일)를 입력해주세요."
                    placeholder="아이디(이메일) 입력"
                    name="email"
                    value={userInfo.email}
                    onChange={onChangeUserInfo}
                    maxLength={100}
                    onKeyDown={onKeyDown}
                  />
                  <Button
                    type="button"
                    className="full silver"
                    onClick={checkDuplicatedId}
                  >
                    중복 확인
                  </Button>
                </div>

                <Input
                  id="user-name"
                  type="text"
                  label="이름을 입력해주세요."
                  placeholder="이름 입력"
                  name="name"
                  value={userInfo.name}
                  onChange={onChangeUserInfo}
                  maxLength={20}
                  onKeyDown={onKeyDown}
                />
                <div className="gs-input-box flex">
                  <Input
                    id="authentication-num"
                    label="인증번호를 입력해주세요."
                    placeholder="인증번호 입력"
                    name="verificationCode"
                    value={userInfo.verificationCode}
                    onChange={onChangeUserInfo}
                    maxLength={6}
                    onKeyDown={onKeyDown}
                  />
                  <Button
                    type="button"
                    className="full silver"
                    // onClick={sendSmsVerifyCode}
                    onClick={sendEmailVerifyCode}
                  >
                    인증번호 요청
                  </Button>
                </div>

                <Input.PasswordEye
                  id="user-password"
                  label="비밀번호를 입력해주세요."
                  placeholder="비밀번호 입력 (영문+숫자+특수문자 조합 8자 이상)"
                  name="password"
                  value={userInfo.password}
                  onChange={onChangeUserInfo}
                  maxLength={20}
                  onKeyDown={onKeyDown}
                />
                <Input.PasswordEye
                  id="user-re-password"
                  label="비밀번호를 입력해주세요."
                  placeholder="비밀번호 확인 입력"
                  name="passwordChk"
                  value={userInfo.passwordChk}
                  onChange={onChangeUserInfo}
                  maxLength={20}
                  onKeyDown={onKeyDown}
                />
                {/* </>

								} */}

                {/* {membershipType === "cris" && */}
                {/* <Input
                  id="user-email"
                  type="text"
                  label="이메일을 입력해주세요."
                  placeholder="이메일 입력"
                  name="email"
                  value={userInfo.email}
                  onChange={onChangeUserInfo}
                  maxLength={100}
                  onKeyDown={onKeyDown}
                /> */}

                <Input
                  id="phone-num"
                  type="tel"
                  label="휴대폰 번호를 입력해주세요."
                  placeholder="휴대폰 번호 입력"
                  name="phone"
                  maxLength={13}
                  value={userInfo.phone}
                  onChange={onChangeUserInfo}
                  onKeyDown={onKeyDown}
                />
                {/* } */}
                <Input
                  id="user-affiliation"
                  type="text"
                  label="소속을 입력해주세요."
                  placeholder="소속 입력"
                  name="company"
                  value={userInfo.company}
                  onChange={onChangeUserInfo}
                  maxLength={30}
                  onKeyDown={onKeyDown}
                />
                <Input
                  id="user-department"
                  type="text"
                  label="부서을 입력해주세요."
                  placeholder="부서 입력"
                  name="department"
                  value={userInfo.department}
                  onChange={onChangeUserInfo}
                  maxLength={30}
                  onKeyDown={onKeyDown}
                />
                <Input
                  id="user-position"
                  type="text"
                  label="직책을 입력해주세요."
                  placeholder="직책 입력"
                  name="position"
                  value={userInfo.position}
                  onChange={onChangeUserInfo}
                  maxLength={20}
                  onKeyDown={onKeyDown}
                />
              </Input.Group>
              <div className="gs-bottom-btns col">
                <Button
                  className="submit"
                  style={{ marginTop: "20px" }}
                  onClick={submit}
                >
                  <strong>가입하기</strong>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {toggleModal.modal?.name === "check-form-dialog" && (
        <Modal
          ariaLabelledby="check-form-dialog"
          handleOpenModal={toggleModal.close}
          className="dialog"
        >
          <Modal.Header>기술사업화지원센터</Modal.Header>
          <Modal.Body className="center">
            아이디를 입력해 주세요.
            {/* 비밀번호를 입력해 주세요. */}
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" onClick={toggleModal.close}>
              <strong>확인</strong>
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </main>
  );
}

// const membershipTypeOptions = [
// 	// {
// 	// 	value: 'cris',
// 	// 	label: '본원',
// 	// 	checked: true,
// 	// },
// 	{
// 		value: 'GENERAL',
// 		label: '일반',
// 		checked: false,
// 	},
// ];

const userInfoDefault = {
  userType: "GENERAL",
  loginId: "",
  password: "",
  passwordChk: "",
  phone: "",
  verificationCode: "",
  name: "",
  email: "",
  company: "",
  department: "",
  position: "",
};
